exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".services[data-v-5b178efe]{display:flex;flex-wrap:wrap;margin:-.25rem}.services .service[data-v-5b178efe]{text-align:center;font-size:12px;flex:1 0 calc(50% - 0.5rem);margin:.25rem!important;padding:.25rem;line-height:1;border-radius:5px;background-color:#f2f2f2;font-weight:700;min-width:max-content}.services .service svg[data-v-5b178efe]{margin-right:.25rem}", ""]);

// exports
